import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ChartService } from 'src/app/services/charts/charts.service';
import { ChartReadyService } from 'src/app/services/charts/chart-ready.service';
import { Chart, registerables } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';

import { MetadataService } from 'src/app/services/metadata/metadata.services';
Chart.register(...registerables);

@Component({
  selector: 'app-radar-chart',
  templateUrl: './radar-chart.component.html',
  styleUrls: ['./radar-chart.component.scss'],
})
export class RadarChartComponent implements OnInit {
  @Input() title = '';
  @Input('inDashboard') isInDashboard: any;
  @Input() chartId = '';
  @Input() chartCategory: any;
  @Input() wideMode = false;
  @Input() subscribed = false;
  @Input() description = '';
  @Input() showUnsubscribedCard = true;
  @Input() pdfMode = false;

  public dataSets: any;
  public chart: any;
  public labels: any;
  public colors: any;

  public default = true;
  isEmpty = false;

  constructor(
    private chartService: ChartService,
    private meta: MetadataService,
    private translate: TranslateService,
    private chartReadyService: ChartReadyService
  ) { }

  ngOnInit(): void {
    if (this.chartId) {
      this.chartReadyService.registerChart(this.chartId);
    }
    setTimeout(() => {
      this.getChartData();
    }, 500);
  }

  getChartData() {
    this.dataSets = this.chartService.getChartDataByCategory(
      this.chartCategory
    );
    this.isEmpty = this.dataSets.every((value: number) => value === 0);
    this.labels = this.meta.getChartLabels(this.chartCategory);
    this.colors = this.meta.getChartColors(this.chartCategory);

    // Si está vacío, marcar como listo inmediatamente (no hay nada que renderizar)
    if (this.isEmpty && this.chartId) {
      console.log(`[RadarChart ${this.chartId}] Empty data, marking ready immediately`);
      this.chartReadyService.markChartReady(this.chartId);
      return;
    }

    setTimeout(() => {
      this.initChart();
    }, 100);
  }

  initChart() {
    // Marcar como no listo mientras se inicializa
    if (this.chartId) {
      this.chartReadyService.markChartNotReady(this.chartId);
    }

    const canvas: any = document.getElementById(this.chartCategory);
    if (!canvas) {
      console.warn('Canvas not ready yet in radar chart');
      return;
    }
    const ctx2 = canvas.getContext('2d');
    let emptySet = 0;

    this.dataSets.forEach((data: any) => {
      emptySet = data === 0 ? emptySet + 1 : emptySet;
    });

    this.default = emptySet === this.dataSets.length;

    // Configuración de animación basada en pdfMode
    const animationConfig = this.pdfMode ? false : {
      duration: 1000,
      onComplete: () => {
        if (this.chartId) {
          this.chartReadyService.markChartReady(this.chartId);
        }
      }
    };

    this.chart = new Chart(ctx2, {
      type: 'radar',
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.dataSets,
            fill: true,
            backgroundColor: this.colors.backgroundColor,
            borderColor: this.colors.borderColor,
            pointBackgroundColor: this.colors.pointBackgroundColor,
            pointBorderColor: this.colors.pointBorderColor,
            pointHoverBackgroundColor: this.colors.pointHoverBackgroundColor,
            pointHoverBorderColor: this.colors.pointHoverBorderColor,
            pointRadius: 4,
          },
        ],
      },

      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: animationConfig as any,
        scales: {
          r: {
            min: 0,
            max: 5,
            ticks: {
              maxTicksLimit: 10,
              display: false,
            },
            angleLines: {
              color: '#70707042',
              lineWidth: 1.5,
            },
            grid: {
              color: '#70707042',
              lineWidth: 1.5,
            },
            pointLabels: {
              color: '#666',
              font: {
                size: 12,
              },
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: ({ label }) => {
                return this.translate.instant(`chartLabels.${label}`);
              },
            },
          },
        },
      },
    });

    // Si modo PDF (sin animación), marcar como listo después del render
    if (this.pdfMode && this.chartId) {
      requestAnimationFrame(() => {
        this.chartReadyService.markChartReady(this.chartId);
      });
    }
  }

  reInitChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.getChartData();
  }
}
